const UploaderMessage = {
  props: {
    thread: { default: false },
    disabled: { default: false },
    endpoint: { default: '/mensajes/archivos/' },
  },

  data: function () {
    return {
      file: false,
      loading: false,
      progress: 0,
    };
  },

  mounted() {
    //console.log('uploader.init');
    UIkit.upload(this.$el, {
      type: 'json',
      name: 'file',
      url: this.endpoint,
      multiple: false,
      //maxSize: 2048, //manualmente después del redimensionado
      allow: '*.(jpg|png|gif|pdf)',
      params: {
        thread: this.thread,
      },

      i18n: UIkitUploadI18n,

      beforeAll: (uploader, files) => {
        //console.log('uploader.beforeAll', uploader, files);
      },
      beforeSend: async (env) => {
        let file = env.data.get('file');

        //console.log(file);
        if (file.type === 'image/jpeg' || file.type === 'image/x-png') {
          file = await resizeImage(file);
        }

        if (file.size > 2 * 1024 * 1024) {
          throw new Error(UIkitUploadI18n.invalidSize);
        }

        env.data.set('file', file);
      },
      loadStart: (e) => {
        //console.log('start', e);
      },
      progress: (e) => {
        this.progress = Math.round((100 * e.loaded) / e.total);
        //console.log('progress', e, this.progress);
      },
      loadEnd: (e) => {
        this.progress = 0;
        //console.log('end', e);
      },
      abort: (e) => {
        console.log(e);
      },
      error: (e) => {
        this.progress = 0;
        let error = e.message;
        switch (e.status) {
          case 413:
            error = UIkitUploadI18n.invalidSize;
        }
        customAlert('Ha ocurrido un error', error);
        console.error(e);
      },
      fail: (e) => {
        customAlert('Ha ocurrido un error', e);
      },
      complete: (xhr) => {
        //console.log('complete', xhr);
        this.$emit('file', xhr.response);
      },
    });
  },

  template: `
      <div class="uk-form-custom uk-flex uk-flex-stretch">
	      <input 
		      type="file" 
		      :disabled="disabled"
          accept="image/jpeg, image/x-png, image/webp, application/pdf"
	      />
	      <button 
		      :disabled="disabled"
		      class="uk-button uk-button-attach" 
	      >Archivo</button>
      </div>
	`,
};
